import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Modal } from '@frontend/design-system';
import { pendoTags } from '../../../../../../../../../shared/constants';
import { useCreateFormStepsStore } from '../../provider';

export interface LocationPickerStepFooterProps {
  onSave: (selectedLocationIds: string[]) => Promise<void>;
}

const LocationPickerStepFooter: FC<LocationPickerStepFooterProps> = ({ onSave }) => {
  const { t } = useTranslation('forms');
  const { selectedLocationIds, setIsCreatingForm } = useCreateFormStepsStore([
    'selectedLocationIds',
    'setIsCreatingForm',
  ]);

  async function saveHandler() {
    setIsCreatingForm(true);
    await onSave(selectedLocationIds);
    setIsCreatingForm(false);
  }

  return (
    <Modal.Footer
      primary={{
        label: t('Save'),
        onClick: saveHandler,
        trackingId: pendoTags.templateGallery.location.save,
        disabled: selectedLocationIds.length === 0,
      }}
      secondary={{
        label: t('Cancel'),
        trackingId: pendoTags.templateGallery.location.cancel,
      }}
    />
  );
};

export default LocationPickerStepFooter;
